export default __webpack_public_path__ + "static/media/deals-icon.8da9f7d5.svg";